import m from "../../geodata/es2015/moldovaHigh";
window.am4geodata_moldovaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/moldovaHigh.js
// module id = null
// module chunks = 